export const __STRAPI__PORT__ =
  process.env.NODE_ENV === "production" ? "/strapi" : ":1337";
export const __STRAPI__HOSTNAME__ = location.hostname;
